import { RoleFlagsAPI } from '@bilancio/api';
import sha256 from 'sha256';
import { FunctionalityInDataGrid } from 'src/app/components/functionalities-data-grid/functionality-in-data-grid.type';
import { UsersManagementDTO } from './users-management.dto';

export class UserChangePasswordModel {
  public static adapt(oldpassword: string, newpassword: string): UserChangePasswordModel {
    const model = new UserChangePasswordModel();
    model.NewPassword = sha256(newpassword);
    model.OldPassword = sha256(oldpassword);
    return model;
  }

  NewPassword: string;
  OldPassword: string;
}

export class UserChangeCurrentUser {
  public static adapt(userDto: UsersManagementDTO): UserChangeCurrentUser {
    const model = new UserChangeCurrentUser();
    model.FirstName = userDto.name;
    model.LastName = userDto.surname;
    return model;
  }

  FirstName: string;
  LastName: string;
}

export class UserManagementModel {
  public static adaptFromDtoToCreate(userDto: UsersManagementDTO): UserManagementModel {
    const userModel = this.adaptGenericDto(userDto);
    userModel.Email = userDto.mail;
    userModel.Password = sha256(sha256(new Date().getTime().toString()));
    return userModel;
  }

  public static adaptFromDtoToUpdate(userDto: UsersManagementDTO): UserManagementModel {
    const userModel = this.adaptGenericDto(userDto);
    userModel.IsDisabled = userDto.state === 0 ? false : true;
    userModel.Id = userDto.id;
    return userModel;
  }

  public static getUserDto(userModel: UserManagementModel): UsersManagementDTO {
    const userDto = new UsersManagementDTO();
    userDto.isAdmin = userModel.IsAdmin;
    userDto.isSuperUser = userModel.IsSuperUser;
    userDto.state = userModel.IsDisabled ? 1 : 0;
    userDto.dateCreation = userModel.DateCreated;
    userDto.id = userModel.Id;
    userDto.name = userModel.FirstName;
    userDto.surname = userModel.LastName;
    userDto.mail = userModel.Email;
    userDto.roleId = userModel.RoleId;
    userDto.roleName = userModel.RoleName;
    userDto.listAziende = userModel.AziendeId ? userModel.AziendeId : [];
    userDto.listPermission = userModel.RoleFlags
      ? userModel.RoleFlags.map(singleRole => {
          const singleFunction = new FunctionalityInDataGrid();
          singleFunction.description = singleRole.RoleName;
          singleFunction.id = singleRole.FuncId;
          singleFunction.order = singleRole.Order;
          singleFunction.editing = {
            disabled: true,
            label: 'Abilita',
            readonly: true,
            value: singleRole.IsEdit,
            visible: true,
          };
          singleFunction.reading = {
            disabled: true,
            label: 'Abilita',
            readonly: true,
            value: singleRole.IsRead,
            visible: true,
          };
          singleFunction.deleting = {
            disabled: true,
            label: 'Abilita',
            readonly: true,
            value: singleRole.IsDelete,
            visible: singleRole.IsEliminaVisibile,
          };
          return singleFunction;
        }).sort((a, b) => a.order - b.order)
      : [];
    return userDto;
  }

  private static adaptGenericDto(userDto: UsersManagementDTO): UserManagementModel {
    const userModel = new UserManagementModel();
    userModel.IsAdmin = userDto.isAdmin;
    userModel.RoleId = userDto.roleId ? '' + userDto.roleId : undefined;
    userModel.FirstName = userDto.name;
    userModel.LastName = userDto.surname;
    userModel.AziendeId = userDto.listAziende ? userDto.listAziende : [];
    userModel.RoleFlags = userDto.listPermission.map(el => ({
      FuncId: el.id,
      Order: el.order,
      RoleName: el.description,
      IsDelete: el.deleting.value,
      IsEdit: el.editing.value,
      IsRead: el.reading.value,
      IsEliminaVisibile: el.deleting.visible,
    }));
    return userModel;
  }

  IsAdmin: boolean;
  IsDisabled: boolean;
  IsSuperUser: boolean;
  DateCreated: Date;
  Id: string;
  RoleId: string;
  Email: string;
  FirstName: string;
  LastName: string;
  RoleName: string;
  Password: string;
  AziendeId: number[];
  RoleFlags: RoleFlagsAPI[];
}
